import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children?: ReactNode
}

interface State {
  error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error: error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
    // TODO: Log error to an analytics service here
  }

  public render() {
    if (this.state.error) {
      return (
        <div
          style={{
            color: '#d32f2f',
            padding: '8px',
            border: '1px solid #d32f2f',
            borderRadius: '5px',
            backgroundColor: '#ffe0e0',
            margin: '8px',
          }}
        >
          {/* Friendly human-readable error message displayed in the User Interface */}
          <p style={{ width: '100%' }}>Internal error: Please try reloading the page.</p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
